<template>
  <div class="date-circle">
    <div
      class="cw font-weight-thin"
      v-if="value.length === 1"
      >
      {{value[0]}}
    </div>
    <template v-else>
      <div
        class="takt-time font-weight-light"
        >
        <div>{{value[0]}}</div>
        <div v-if="value[0] !== value[1]"> - </div>
        <div v-if="value[0] !== value[1]">{{value[1]}}</div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: ['value'],
  data: () => ({
  }),
}
</script>
<style>
  .date-circle {
    display: flex;
    height: 100%;
    width: 100%;
    max-width: 65px;
    border-radius: 100%;
    border: solid var(--v-primary-base) 1px;
    justify-content: center;
    align-items: center;
    text-align: center;
    line-height: min(15px, calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom) * 0.13));
    cursor: pointer;
  }
  .cw {
    font-size: min(30px, calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom) * 0.4));
  }
  .takt-time {
    font-size: min(15px, calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom) * 0.2));
  }
</style>
